var exports = {
  "kL": "xfd349460--8caa28--container",
  "wm": "xfd349460--8caa28--logo",
  "nf": "xfd349460--8caa28--link",
};

module.exports = exports;
